import { useOneOfPermissionRequiredStrategy, useAllOfPermissionRequiredStrategy } from '@/guards';
import { Route, NavigationGuard } from 'vue-router';

export const permissionsGuard: NavigationGuard = (to, _, next) => {

  if (hasRouteProp(to, 'requiredOneOfPermissions')) {
    return useOneOfPermissionRequiredStrategy(to, next);
  } else if (hasRouteProp(to, 'requiredPermissions')) {
    return useAllOfPermissionRequiredStrategy(to, next);
  }

  next();
};

function hasRouteProp(route: Route, key: string) {
  return route.matched[0].meta.hasOwnProperty(key);
}
